import React, { useState } from "react";
//import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ExceptionOutlined } from "@ant-design/icons";
import { Button } from "antd";
import dayjs from "dayjs";
import { sleep } from "../utils/apiUtils";
import Swal from "sweetalert2";

import ExcelJS from "exceljs";
import { blue } from "@mui/material/colors";

function ExportTable({
  data,
  columns,
  fileName = "report_",
  reportName = "",
  timeRange,
}) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (data.length > 200000) {
      Swal.fire({
        icon: "error",
        title: "คำเตือน",
        text: "ไม่สามารถส่งออกเป็นไฟล์ Excel ได้เนื่องจากปริมาณข้อมูลเยอะเกินไป ข้อมูลที่ส่งออกได้จะต้องไม่เกิน 200,000 รายการ",
        confirmButtonText: "ตกลง",
        confirmButtonColor:blue[500]
      });
      return;
    }
    setLoading(true);
    await sleep(100);
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "LCCM";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.mergeCells("A1:H1");
    worksheet.getCell("A1").value = `รายงาน : ${reportName}`;
    worksheet.getCell("A1").font = {
      italic: true,
      bold: true,
      size: 16,
      color: { argb: "FFFFFFFF" },
    };
    worksheet.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4CAF50" },
    };

    worksheet.mergeCells("A2:H2");
    worksheet.getCell("A2").value = `วันที่ออกรายงาน: ${dayjs(
      timeRange.dateStart
    ).format("D MMMM YYYY")} - ${dayjs(timeRange.dateEnd).format(
      "D MMMM YYYY"
    )}`;
    worksheet.getCell("A2").font = {
      italic: true,
      size: 12,
      color: { argb: "FFFFFFFF" },
    };
    worksheet.getCell("A2").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4CAF50" },
    };

    worksheet.addRow(columns.map((column) => column.title));
    const excelData = data.map((item) =>
      columns.map((column) => item[column.dataIndex])
    );
    worksheet.addRows(excelData);

    // จัดรูปแบบเซลล์ (สี, เส้นขอบ)
    const headerRow = worksheet.getRow(3);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    // กำหนดความกว้างของคอลัมน์ให้พอดีกับจำนวนตัวอักษร
    const maxColWidth = excelData.reduce(
      (acc, row) => {
        return row.reduce((acc, cell, index) => {
          const cellLength = cell ? cell.toString().length : 0;
          if (cellLength > acc[index]) {
            acc[index] = cellLength;
          }
          return acc;
        }, acc);
      },
      columns.map(() => 0)
    );

    worksheet.columns.forEach((column, index) => {
      column.width =
        maxColWidth[index] > columns[index].title.length
          ? maxColWidth[index] + 2
          : columns[index].title.length + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
    setLoading(false);
  };

  /*const handleExportOld = async () => {
    if (data.length > 200000) {
      Swal.fire({
        icon: "error",
        title: "คำเตือน",
        text: "ไม่สามารถส่งออกเป็นไฟล์ Excel ได้เนื่องจากปริมาณข้อมูลเยอะเกินไป ข้อมูลที่ส่งออกได้จะต้องไม่เกิน 200,000 รายการ",
      });
      return;
    }

    setLoading(true);
    await sleep(100);
    const excelData = data.map((item) =>
      columns.map((column) => item[column.dataIndex])
    );
    const worksheet = XLSX.utils.aoa_to_sheet([
      columns.map((column) => column.title),
      ...excelData,
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
    setLoading(false);
  };*/
  return (
    <Button
      disabled={data.length === 0}
      type="text"
      icon={<ExceptionOutlined />}
      loading={loading}
      onClick={handleExport}
    >
      Export to Excel
    </Button>
  );
}

export default ExportTable;
